import React from 'react';
import PropTypes from 'prop-types';

const TopAdvice = ({ className, children }) => (
  <div className={className}>
    <div>
      <span>{children}</span>
    </div>
  </div>
);

TopAdvice.propTypes = {
  className: PropTypes.string,
};

TopAdvice.defaultProps = {
  className: '',
};

export default TopAdvice;
